var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-circle-container"},[_c('div',{ref:"timecircles"})])
}
var staticRenderFns = []

export { render, staticRenderFns }